import React from 'react';
import LoginWrapper from '../../module/login/LoginWrapper';

const LoginPage = ({ isWeb }: { isWeb?: boolean }) => {
  return <LoginWrapper isWeb={isWeb} />;
};

export default LoginPage;
